module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/dinners-logo-4684102b02bfa5f973055ec9992f3ea7.svg";